const initClipboardCopy = function (){

    const elements = document.querySelectorAll('.copy-clipboard:not(.copy-initialised)'); //also has ajax, so we do not use .initialised, as ajax uses this class.

    elements.forEach(element => {
        element.addEventListener('click', e => {
            e.preventDefault();
            const trigger = element;
            trigger.blur();
            let value;
            if (trigger.dataset.value) {
                value = trigger.dataset.value;
            }
            if (trigger.dataset.target) {
                value = document.querySelector(trigger.dataset.target).innerHTML.replace(/&lt;/g, '<').replace(/&gt;/g, '>');
            }

            if (value) {
                const temp = document.createElement('input');
                document.body.appendChild(temp);
                temp.value = value;
                temp.select();
                document.execCommand('copy');
                document.body.removeChild(temp);
            }
        })
        element.classList.add('copy-initialised');
    })

}

export default initClipboardCopy;